module.exports = __webpack_public_path__ + "static/media/b3_p7_crystal.d39beaf5.mp3";